import React, { useState } from 'react';
import { Collapse } from '@mui/material';
import cx from 'classnames';
import { ReactComponent as ArrowIcon } from './images/arrow.svg';
import css from './TableItem.module.scss';

type TTableItem = {
  item: any[];
  collapse: { key: string; value: string | null }[];
};

export const TableItem = ({ item, collapse }: TTableItem) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <div className={css.root}>
      <div className={css.item}>
        {item.map((item, index) => (
          <div key={`item_${index}`} className={css[`col${index + 1}`]}>{item}</div>
        ))}
      </div>
      {collapse.length && (
        <ArrowIcon
          className={cx(css.icon, isOpen && css.isOpen)}
          onClick={() => setOpen(!isOpen)}
        />
      )}
      {collapse.length && (
        <Collapse in={isOpen}>
          <ul className={css.collapse}>
            {collapse.map((item, index) => item.value && (
              <li className={css.listItem} key={`collapse_${index}`}>
                <div className={css.key}>{item.key}</div>
                <div>{item.value}</div>
              </li>
            ))}
          </ul>
        </Collapse>
      )}
    </div>
  );
};
